



const MAIN_BASE_URL= "https://api.yellowcalf.com:3000/";//live 
// const MAIN_BASE_URL= "https://api.stage.yellowcalf.com:3001/";//amer 

const BASE_URL = MAIN_BASE_URL;//live 


const ApiConfig = {
    BASE_URL:BASE_URL,
    SEND_OTP: BASE_URL + "/api/user/sendOtp",
    LOGIN: BASE_URL + "api/accountant/login",
    dashboradlist:BASE_URL + "api/accountant",
    dashboradStudentList:BASE_URL + "api/accountant/default/studentattendance",
    ProfileView:BASE_URL + "api/accountant/user-profile/view",
    UpdateProfileView:BASE_URL + "api/accountant/user-profile/update",
    UpdateProfileChangePAssword:BASE_URL + "api/accountant/user-profile/password-change",
    FeeStudentList:BASE_URL + "api/accountant/feeFrequency/list",
    FeeStudentListView:BASE_URL + "api/accountant/feeFrequency/view", 
    feeCategorylist:BASE_URL+"api/accountant/feeCategory/list",
    feeCategoryview:BASE_URL+"api/accountant/feeCategory/view",
    feeCategorycreate:BASE_URL+"api/accountant/feecategory/create",
    feeCategoryEDit:BASE_URL+"api/accountant/feeCategory/edit",
    feeCategoryDELETE:BASE_URL+"api/accountant/feeCategory/delete",
    feeStructurelist:BASE_URL+"api/accountant/feeStructure/list",
    viewFeeStructure:BASE_URL+"api/accountant/feeStructure/view",
    editFeeStructure:BASE_URL+"api/accountant/feestructure/edit",
    viewFeeStructure:BASE_URL+"api/accountant/feeStructure/view",
    feeStructurecatogorylist:BASE_URL+"api/accountant/feeStructure/catogory/list",
    integrationsettings:BASE_URL+"api/accountant/integration/settings",
    parentintegrationsettingsget:BASE_URL+"api/accountant/notification/getSettings",
    parentintegrationsettingsUpdate:BASE_URL+"api/accountant/notification/settings",
    invoicelayout:BASE_URL+"api/accountant/invoice/layout",
    receiptlayout:BASE_URL+"api/accountant/receipt/layout",
    billviewList:BASE_URL+"api/accountant/bill",
    paidBills:BASE_URL+"api/accountant/bill/paid_bill",
    paidViewBill:BASE_URL+"api/accountant/bill/paid_view",
    billview:BASE_URL+"api/accountant/bill/view",
    billIndex:BASE_URL+"api/accountant/bill/index",
    billCreate:BASE_URL+"api/accountant/bill/create",
    billUpdate:BASE_URL+"api/accountant/bill/update",
    billDeleteItem:BASE_URL+"api/accountant//bill/delete-item",
    billItemsList:BASE_URL+"api/accountant/bill/itemslist",
    incomeList:BASE_URL+"api/accountant/income/list",
    incomeDelete :BASE_URL+"api/accountant/income/delete",
    incomeView :BASE_URL+"api/accountant/income/view",
    incomeUpdate :BASE_URL+"api/accountant/income/update",
    incomeCreate :BASE_URL+"api/accountant/income/create",
    bankList :BASE_URL+"api/accountant/bank/list",
    bankDelete :BASE_URL+"api/accountant/bank/delete",
    bankView :BASE_URL+"api/accountant/bank/view",
    bankUpdate :BASE_URL+"api/accountant/bank/update",
    bankCreate :BASE_URL+"api/accountant/bank/create",
    expenseTypeList :BASE_URL+"api/accountant/expensetype/list",
    expenseTypeUpdate :BASE_URL+"api/accountant/expensetype/update",
    expenseTypeCreate :BASE_URL+"api/accountant/expensetype/create",
    expenseTypeDelete :BASE_URL+"api/accountant/expensetype/delete",
    incomeTypeList :BASE_URL+"api/accountant/incometype/list",
    incomeTypeUpdate :BASE_URL+"api/accountant/incometype/update",
    incomeTypeCreate :BASE_URL+"api/accountant/incometype/create",
    incomeTypeDelete :BASE_URL+"api/accountant/incometype/delete",
    incomeDropdowns :BASE_URL+"api/accountant/income/dropdowns",
    upcomingFeeInvoice:BASE_URL+"api/accountant/upcomingFeeInvoice",
    CreateFeeInvoicespecialfee:BASE_URL+"api/accountant/specialfee",
    collectparentpaymen:BASE_URL+"api/accountant/collectparentpayment",
    pendingInvoice:BASE_URL+"api/accountant/feeinvoice/pending",
    invoiceTemplateExport:BASE_URL+"api/accountant/invoice-template-export",
    studentlist:BASE_URL+"api/accountant/studentlist-parent",
    categorytype:BASE_URL+"api/accountant/fee-category-type-list",
    termstype:BASE_URL+"api/accountant/master-academic-terms-list",
    createFeeStructure:BASE_URL+"api/accountant/feestructure/create",
    deleteFeeStructure:BASE_URL+"api/accountant/feeStructure/delete",
    classlist:BASE_URL+"api/accountant/class-list",
    Studentclasslist:BASE_URL+"api/accountant/student-by-class",
    academicyear:BASE_URL+"api/accountant/academic-year",
    feeinvoiceAdd:BASE_URL+"api/accountant/feeinvoice/arrears",
    importarrears:BASE_URL+"api/accountant/importarrears",
    smsbulksend:BASE_URL+"api/accountant/feeinvoice/pending/bulksend",
    feeinvoiceView:BASE_URL+"api/accountant/feeinvoice/view",
    parentfailedtransaction:BASE_URL+"api/accountant/parentfailedtransaction/list",
    supplierList:BASE_URL+"api/accountant/supplier/list",
    supplierCreatePost:BASE_URL+"api/accountant/supplier/create",
    supplierEditPost:BASE_URL+"api/accountant/supplier/update",
    supplierView:BASE_URL+"api/accountant/supplier/view",
    supplierDelete:BASE_URL+"api/accountant/supplier/delete",
    billDelete:BASE_URL+"api/accountant/bill/Delete",
    parentfailedtransactionUPDATE:BASE_URL+"api/accountant/parentfailedtransaction/update",
    parentfailedtransactionView:BASE_URL+"api/accountant/parentfailedtransaction/view",
    collectRegistrationFee:BASE_URL+"api/accountant/collectRegistrationFee/search",
    customersList:BASE_URL+"api/accountant/student-find-customers",
    customersListView:BASE_URL+"api/accountant/collectRegistrationFee/view",
    Adddiscount:BASE_URL+"api/accountant/add-discount",
    getassets:BASE_URL+"api/accountant/get-assets",
    createassets:BASE_URL+"api/accountant/create-asset",
    Updateassets:BASE_URL+"api/accountant/update-asset",
    Deleteeassets:BASE_URL+"api/accountant/delete-asset",
    vieweeassets:BASE_URL+"api/accountant/view-asset",
    Getiscount:BASE_URL+"api/accountant/get-discount",
    SendInvice:BASE_URL+"api/accountant/feeInvoice/sendsms",
   collection1Report:BASE_URL+"api/accountant/expense/collection1",
   expensesList:BASE_URL+"api/accountant/expenses/list",
   expensesListView:BASE_URL+"api/accountant/expenses/view",
   expensesListDelete:BASE_URL+"api/accountant/expenses/delete",
   expensescreate:BASE_URL+"api/accountant/expenses/create",
   expensesUpdate:BASE_URL+"api/accountant/expenses/update",
   AccountTypeUpdate:BASE_URL+"api/accountant/accounttype/update",
   AccountTypeDelete:BASE_URL+"api/accountant/accounttype/delete",
   AccountTypeView:BASE_URL+"api/accountant/accounttype/view",
   AccountTypeAdd:BASE_URL+"api/accountant/accounttype/create",
   AccountTypeList:BASE_URL+"api/accountant/accounttype/list",
   expensesaccounttype:BASE_URL+"api/accountant/accounttype/list",
   expensestype:BASE_URL+"api/accountant/expensetype/list",
    CustomerView:BASE_URL+"api/accountant/getinvoiceinfo",
    YearlyIncomeSummaryReport:BASE_URL+"api/accountant/expense/feepaid",
    Yselectedinvoice:BASE_URL+"api/accountant/feeinvoice/selectedinvoice",
   typesdropdownAssies:BASE_URL+"api/accountant/asset/types-dropdown",
    InvoiceBalanceReport:BASE_URL+"api/accountant/reports/invoice",
    InvoiceagingReport:BASE_URL+"api/accountant/reports/aging",
    siblingsreportsReport:BASE_URL+"api/accountant/siblingsreports",
    balancereportsreportsReport:BASE_URL+"api/accountant/balancereports",
    specialfeereports:BASE_URL+"api/accountant/specialfeereports",
    paymentmodereportports:BASE_URL+"api/accountant/paymentmodereport",
   assetmodereportports:BASE_URL+"api/accountant/asset-report",
   studentpaymentsRports:BASE_URL+"api/accountant/student-payments",
   feeinvoiceDelete:BASE_URL+"api/accountant/feeinvoice/delete",
   termwiseRports:BASE_URL+"api/accountant/term-wise-report",
    operatorsaleports:BASE_URL+"api/accountant/wallet/operatorsale",
    salesreporteports:BASE_URL+"api/accountant/wallet/walletsale/salesreport",
    cashlessWalletreporteports:BASE_URL+"api/accountant/wallet/cashlessWallet",
    

    


}

export default ApiConfig